var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('one')],1),_c('div',{staticClass:"col"},[_c('two')],1),_c('div',{staticClass:"col"},[_c('three')],1),_c('div',{staticClass:"col"},[_c('four')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }